/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call,
  @typescript-eslint/no-explicit-any */
const groupByKey = (list, key) => list
    .reduce((hash, obj) => (Object.assign(Object.assign({}, hash), { [obj[key]]: (hash[obj[key]] || []).concat(obj) })), {});
export default groupByKey;
